import {Component, inject, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {RepoService} from "../services/repo.service";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatInput} from "@angular/material/input";
import {AsyncPipe, JsonPipe} from "@angular/common";
import {Observable} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-site-categories',
  standalone: true,
  imports: [
    FormsModule,
    MatButton,
    MatInput,
    MatFormField,
    AsyncPipe,
    JsonPipe
  ],
  templateUrl: './site-categories.component.html',
  styleUrl: './site-categories.component.css'
})
export class SiteCategoriesComponent implements OnInit {

  jsonInput: string = '';
  errorMessage: string = '';

  public repoService = inject(RepoService);
  public snackBar = inject(MatSnackBar);
  siteMessage$: Observable<Object | null>;


  ngOnInit(): void {
    this.siteMessage$ = this.repoService.listenToSiteCategories()
  }

  async saveToFirestore() {
    try {
      //removes duplicates
      const parsedObject = JSON.parse(this.jsonInput);

      if (typeof parsedObject !== 'object' || Array.isArray(parsedObject)) {
        this.snackBar.open("Error! Input should be a JSON object.", "Close")
        return;
      }

      await this.repoService.updateSiteCategories({data: parsedObject})

      this.snackBar.open("Data saved successfully!", "Close")
    } catch (error) {
      this.snackBar.open("Error! Invalid JSON format.", "Close")
      throw Error(error)
    }
  }

  async copyToClipboard(sites: Object) {
    const jsonString = JSON.stringify(sites, null, 2); // Format JSON for readability
    await navigator.clipboard.writeText(jsonString)
  }
}
